<template>
  <div>
    <hero></hero>
    <about-us></about-us>
    <why-us></why-us>
    <faq></faq>
    <roadmap></roadmap>

    <!-- <custom-controls></custom-controls> -->
    <!-- <navigation></navigation> -->
    <!-- <javascript-components></javascript-components>
    <icons></icons>
    <examples></examples>
    <download-section></download-section>
    <carousel></carousel> -->
  </div>
</template>
<script>
import Hero from "./components/Hero";
import AboutUs from "./components/AboutUs";
import WhyUs from "./components/WhyUs";
import Faq from "./components/Faq";
import Roadmap from "./components/Roadmap";
import CustomControls from "./components/CustomControls";
import Navigation from "./components/Navigation";
import JavascriptComponents from "./components/JavascriptComponents";
import Carousel from "./components/Carousel";
import Icons from "./components/Icons";
import Examples from "./components/Examples";
import DownloadSection from "./components/DownloadSection";

export default {
  name: "components",
  components: {
    Hero,
    AboutUs,
    WhyUs,
    Faq,
    Roadmap,
    CustomControls,
    Navigation,
    JavascriptComponents,
    Carousel,
    Icons,
    Examples,
    DownloadSection,
  },
};
</script>
